const DULL_ACTION_TYPES = {
  LOAD_DULL: 'dull/LOAD_DULL',
};

export default DULL_ACTION_TYPES;
